import React from 'react';
import HoverIcon from '../HoverIcon';
import ProofGraphic from '../../assets/gmb/gmbProof.svg';
import LeadsGraphic from '../../assets/gmb/gmbLeads.svg';
import utmUrl from '../../utils/utmUrl';
import GrowBusinessGraphic from '../../assets/gmb/gmbGrowBusiness.svg';
import './styles.css';

const types = {
  proof: {
    title: 'Future-proof your business',
    subTitle: 'with stress-free digital marketing',
    icon: ProofGraphic,
    link: utmUrl('https://business.localsearch.com.au/', {
      medium: 'gmb_banner',
      campaign: 'advertise-your-business',
    }),
    buttonText: 'Find out more',
  },
  leads: {
    title: 'Increase your leads',
    subTitle: 'with a Google Premier Partner.',
    icon: LeadsGraphic,
    link: utmUrl(
      'https://business.localsearch.com.au/search-engine-marketing/',
      {
        medium: 'gmb_banner',
        campaign: 'search-engine-marketing',
      }
    ),
    buttonText: 'Find out more',
  },
  growBusiness: {
    title: 'Grow your business 24/7',
    subTitle: 'A website is there when you can’t be.',
    icon: GrowBusinessGraphic,
    link: utmUrl(
      'https://business.localsearch.com.au/website-design-development/',
      {
        medium: 'gmb_banner',
        campaign: 'websites',
      }
    ),
    buttonText: 'Get started',
  },
};

const GmbBanner = ({ type }) => {
  const { title, subTitle, icon, link, buttonText } = types[type] || {};

  return (
    <div className="GmbBanner__root">
      <div className="GmbBanner__icon">
        <img src={icon} alt={type} />
      </div>
      <div className="GmbBanner__content">
        <div className="GmbBanner__title">{title}</div>
        <div className="GmbBanner__subTitle">{subTitle}</div>
        <HoverIcon icon="icon-generalcaretrightsmall">
          <a target="_blank" rel="noopener noreferrer" href={link}>
            {buttonText}
          </a>
        </HoverIcon>
      </div>
    </div>
  );
};
export default GmbBanner;
